import { makeStyles } from "@material-ui/core";


export default makeStyles(() => ({
    dateInput: {
        backgroundColor: "#fbfbfb",
        boxShadow: "rgba(17, 17, 26, 0.1) 0px 0.5px 0px"
    }
}));